import { SelectChangeEvent } from '@mui/material/Select/SelectInput';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { SortOption } from 'src/util/sortOptions';

type SortDropdownProps = {
  sortOptions: SortOption[];
  currentSortOption?: SortOption;
  handleSortChange: (e: SelectChangeEvent) => void;
};

export function SortDropdown({
  handleSortChange,
  sortOptions,
  currentSortOption,
}: SortDropdownProps) {
  return (
    <Select
      defaultValue={currentSortOption?.name}
      value={currentSortOption?.name}
      onChange={handleSortChange}
      inputProps={{
        name: 'sortDropdown',
        id: 'sortDropdown',
        sx: { py: 2 },
      }}
    >
      {sortOptions.map((option) => {
        return (
          <MenuItem key={option.name} value={option.name}>
            {option.name}
          </MenuItem>
        );
      })}
    </Select>
  );
}
